import { Tabs } from "antd";
import styles from './Customers.module.css';
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import JobDetailsTab from "../JobDetails/JobDetailsTab";
import CreateCustomer from "../CreateCustomer/CreateCustomer";
import { useState } from "react";
import { SearchInput } from "../../../components";
import { useTranslation } from "react-i18next";

const Customers = () => {
  const { t, i18n } = useTranslation();
  const { width, height } = useWindowDimensions();
  const [Active, setActive] = useState();
  const [search, setsearch] = useState();
  const items = [
    {
      key: "1",
      label: `${t("Job Details")}`,
      children: <JobDetailsTab />,
    },
    {
      key: "2",
      label: `${t("Create Customer")}`,
      children: <CreateCustomer />,
    },
  ];

  const onChange = (key) => {
    console.log(key);
  };
  return (
    <div style={{ margin: "0px 30px",width:'90%' }}>
      <h1 className={styles.heading}>{t("Customers")}</h1>

      {/* <div className={styles.used_search_input}>
        <SearchInput
          placeholder={"Search"}
          onChange={(e) => setsearch(e.target.value)}
        />
      </div> */}
      <Tabs
        className="tab_content_styling"
        size="large"
        defaultActiveKey="1"
        items={items}
        tabBarGutter={width > 570 ? 50 : 5}
        // centered
        onChange={onChange}
        tabBarStyle={
          width > 570
            ? {
                color: "white",
                fontWeight: "bold",
                width: "100%",
                margin: "0px 40px",
              }
            : {
                color: "white",
                fontSize: "8px",
              }
        }
      />
    </div>
  );
};
export default Customers;
